import { render } from "./NotFoundPage.vue?vue&type=template&id=25cc44ee"
import script from "./NotFoundPage.vue?vue&type=script&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__